import { newsletterForm } from "./src/newsletter";
import { Consent } from "./src//Consent";

window.addEventListener("load", () => {
  newsletterForm();
  Consent();
});
